// Shared case-type filtering for case note templates (participant case page and Caseload Review).
export const filterCaseNoteTemplates = (templates, selectedCase) => {
  if (!templates || templates.length === 0) return [];
  if (!selectedCase) return templates;

  const caseEnrollmentType = selectedCase.enrollment_type_id || selectedCase.enrollment_type || '';
  const caseProgramName = (selectedCase.program_name || '').toLowerCase();
  const caseProgramType = selectedCase.program_type || '';
  if (!caseEnrollmentType && !caseProgramName && !caseProgramType) return templates;

  const filtered = templates.filter((template) => {
    if (!template.case_types || template.case_types.length === 0) return true;
    return template.case_types.some((ctId) => {
      if (!ctId) return false;
      const ctIdLower = ctId.toLowerCase();
      if (caseEnrollmentType && ctIdLower === caseEnrollmentType.toLowerCase()) return true;
      if (caseProgramType && ctIdLower === caseProgramType.toLowerCase()) return true;
      if (caseProgramName) {
        const normalizedProgramName = caseProgramName.replace(/[^a-z0-9]/g, '');
        const normalizedCtId = ctIdLower.replace(/[^a-z0-9]/g, '');
        if (normalizedProgramName.includes(normalizedCtId)) return true;
        if (normalizedCtId.includes(normalizedProgramName)) return true;
        const programParts = caseProgramName.split(/[\s\-&]+/).filter((p) => p.length > 2);
        const ctParts = ctIdLower.split(/[_\-\s]+/).filter((p) => p.length > 2);
        for (const pp of programParts) {
          for (const cp of ctParts) {
            if (pp === cp || pp.includes(cp) || cp.includes(pp)) return true;
          }
        }
      }
      return false;
    });
  });
  // Never hide everything because of a mismatch
  return filtered.length === 0 ? templates : filtered;
};
